<template>
    <div>
        <b-row>
            <b-col>
                <p class="mb-1 ml-1 text-muted text-uppercase">
                    <small>
                        <i class="icon-speech"></i>
                        {{ $t('targets.informations.moreInformations') }}
                    </small>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-list-group>
                    <b-list-group-item
                        class="d-flex justify-content-between align-items-center"
                    >
                        <small class="text-muted title"
                            >{{ $t('form.label.owner') }}:</small
                        >
                        <b-badge variant="light" class="text-muted" pill>{{
                            data.owner
                        }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item
                        class="d-flex justify-content-between align-items-center"
                    >
                        <small class="text-muted title"
                            >{{ $t('form.label.period') }}:</small
                        >
                        <b-badge variant="light" class="text-muted" pill>{{
                            data.period
                        }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item
                        class="d-flex justify-content-between align-items-center"
                    >
                        <small class="text-muted title"
                            >{{ $t('form.label.level') }}:</small
                        >
                        <b-badge variant="light" class="text-muted" pill>{{
                            data.level
                        }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item
                        class="d-flex justify-content-between align-items-center"
                    >
                        <small class="text-muted title"
                            >{{ $t('form.label.yearToDate') }}:</small
                        >
                        <b-badge variant="light" class="text-muted" pill>{{
                            data.yearToDate
                        }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item
                        v-if="data.hasTriggerGoal != null"
                        class="d-flex justify-content-between align-items-center"
                    >
                        <small class="text-muted title"
                            >{{ $t('form.label.triggerGoal') }}:</small
                        >
                        <b-badge variant="light" class="text-muted" pill>{{
                            data.hasTriggerGoal
                        }}</b-badge>
                    </b-list-group-item>
                    <b-list-group-item
                        class="d-flex justify-content-between align-items-center"
                    >
                        <small class="text-muted title"
                            >{{ $t('form.label.unitOfMeasurement') }}:</small
                        >
                        <b-badge variant="light" class="text-muted" pill>{{
                            data.UnitOfMeasurement || '-'
                        }}</b-badge>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'Informations',
    props: ['data'],
}
</script>
